// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addTagsModalStyles } from "@adl/Overrides/Widgets/MyListsDetails/AddTagsModal";
import { modalButtonsActionStyles } from "@adl/XDL/Utilities/sharedStyles";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

addTagsModalStyles.container = {
    gap: 0,
};

addTagsModalStyles.buttonsGridItem = modalButtonsActionStyles.buttonsGridItem;

addTagsModalStyles.cancelButton = modalButtonsActionStyles.cancelButton;

addTagsModalStyles.saveButton = modalButtonsActionStyles.submitButton;

addTagsModalStyles.tagsInstructionGridItem = {
    width: 12,
    css: css`
        padding-bottom: 20px;
    `,
};

addTagsModalStyles.descriptionGridItem = {
    width: 12,
    css: css`
        padding-bottom: 20px;
    `,
};

addTagsModalStyles.tagsGridItem = {
    width: 12,
};

addTagsModalStyles.tagText = {
    css: css`
        display: flex;
        background: ${getColor("primary.main")};
        color: ${getColor("primary.contrast")};
        &:hover {
            background: #1b3f76;
        }
        border-radius: 4px;
        white-space: nowrap;
        margin-right: 6px;
        margin-bottom: 6px;
        padding: 2px 6px;
        font-size: 15px;
        align-items: center;
        text-wrap: wrap;
    `,
};

addTagsModalStyles.fakeTextFieldStyle = {
    isFocused: false,
} as any;

addTagsModalStyles.tagInputText = {
    css: css`
        width: 100%;
        background: transparent;
        border: none !important;
        flex-grow: 1;
        font-family: inherit;
        font-size: inherit;
        margin-bottom: 9px;
        &:focus {
            outline: none;
        }
    `,
    cssOverrides: {
        formInputWrapper: css`
            &&& input {
                box-shadow: none;
            }
        `,
    },
};

addTagsModalStyles.tagStyles = {
    typographyProps: {
        ellipsis: true,
        css: css`
            width: 100%;
            text-align: left;
            margin: 5px 0;
        `,
    },

    iconProps: {
        css: css`
            margin: 6px;
        `,
    },
    css: css`
        padding: 0 3px 0 10px;
        min-height: 0;
        &&&& {
            max-width: 100%;
        }
    `,
};
